<template>
  <div>
    <b-modal no-close-on-backdrop hide-footer id="new_code" title="NOVO CÓDIGO">
      <form @submit.prevent="create">
        <WarningRequiredFields />
        <ErrorsMessages :errors="errors" />
        <div class="row">
          <div class="col-md-12 pt-0 pb-0">
            <v-autocomplete-default
              label="FORNECEDOR"
              :items="providers"
              :item-text="providerText"
              itemText="company_name"
              v-model="provider_id"
              required
            />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <LabelRequiredField label="CÓDIGO" />
            <input v-model="code" type="text" class="form-control" />
          </div>
          <div class="col-md-12 text-right pb-0">
            <v-btn :disabled="loading" type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "SALVAR" }}
            </v-btn>
          </div>
        </div>
      </form>
    </b-modal>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn type="button" class="btn-add" @click="handleModalCreate">
          <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR CÓDIGO
        </v-btn>
      </div>
      <div class="col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <div
            class="v-clean p-5 text-center"
            v-show="stock_item_provider_code.length == 0"
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="stock_item_provider_code.length > 0"
            dense
            :headers="headers"
            :items="stock_item_provider_code"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.code`]="{ item }">
              {{ item.code }}
            </template>
            <template v-slot:[`item.company_name`]="{ item }">
              {{ item.company_name }}
              <span class="ml-2" v-if="item.fantasy_name"
                >- <small>Nome fantasia ({{ item.fantasy_name }})</small></span
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <Edit :providers="providers" :item="item" @success="get()" />
              <v-btn
                class="btn-edit"
                small
                @click="$bvModal.show(`view_code-${item.id}`)"
              >
                <i class="fas fa-edit mr-2"></i>
                EDITAR
              </v-btn>
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import VAutocompleteDefault from "../Components/VAutocompleteDefault";

import Edit from "./edit";

import api from "../../services/api";

import APIGet from "../../lib/api-get";

import toast from "../../lib/ToastNotification";

export default {
  name: "ProviderCode",
  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    VAutocompleteDefault,
    Edit,
  },

  props: {
    type: String,
    stock_item_id: [String, Number],
  },

  data() {
    return {
      code: "",

      providerText: "",
      provider_id: "",
      providers: [],

      stock_item_provider_code: [],

      errors: [],
      loading: false,

      headers: [
        { text: "FORNECEDOR", value: "company_name" },
        { text: "CÓDIGO", value: "code" },
        { text: "", value: "action", sortable: false },
      ],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleModalCreate() {
      this.errors = [];
      this.provider_id = "";
      this.code = "";
      this.$bvModal.show("new_code");
    },

    retrieve() {
      this.get();
      this.getProviders();
    },

    async get() {
      try {
        this.loading = true;

        let { stock_item_id, type } = this;

        let params = { stock_item_id, type };

        const response = await api.get(
          "/rest-home/stock/stock-item-provider-code",
          {
            params,
          }
        );

        const { error, errors, stock_item_provider_code } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.stock_item_provider_code = stock_item_provider_code;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getProviders() {
      this.loading = true;
      const { error, errors, providers } = await APIGet.getProviders();
      this.errors = errors;
      this.providers = error
        ? []
        : [{ id: "", company_name: "SELECIONE..." }, ...providers];
      this.loading = false;
    },

    async create() {
      try {
        this.loading = true;

        let { provider_id, type, stock_item_id, code } = this;

        let params = {
          imported_nfe: false,
          provider_id,
          type,
          stock_item_id,
          code,
        };

        const response = await api.post(
          "/rest-home/stock/stock-item-provider-code",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_code");
          this.get();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
